/**
 * The board's bridge pages: `master.integrations.manage` or not found, in the office's scope.
 */
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '@insio/ui-toolkit';
import { MasterAccountPermission } from '@insio/shared-types';
import { useMasterPermissions } from '@/features/auth';
import { OfficeBridgeScope } from '../../context/BridgeScopeContext';

/** Not found inside the Nastavení kanceláře section, without a second page around it. */
export function MasterAccountBridgesNotFound() {
  const { t } = useTranslation();
  return (
    <EmptyState
      testId='master-account-bridges-not-found'
      icon='circle-xmark'
      message={t('error.notFound.title')}
      description={t('error.notFound.message')}
    />
  );
}

export function MasterAccountBridgesGate({ children }: { children: ReactNode }) {
  const { hasMasterPermission } = useMasterPermissions();

  if (!hasMasterPermission(MasterAccountPermission.INTEGRATIONS_MANAGE)) {
    return <MasterAccountBridgesNotFound />;
  }

  return <OfficeBridgeScope>{children}</OfficeBridgeScope>;
}
